module.exports = __webpack_public_path__ + "static/media/prusa-1.dd9e8e2a.jpg";